import styled from "styled-components";
import Avatar from "@material-ui/core/Avatar";
import CardHeader from "@material-ui/core/CardHeader";
import { Row } from "antd";

export const Container = styled.div`
  display: flex;
  align-items: center;
  max-height: 3rem;
`;

export const HeaderContainer = styled(Row)`
  display: flex;
  justify-content: space-between;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledHeader = styled(CardHeader)`
  flex: 1;
  margin: auto;
  padding: 0;

  > div {
    margin-right: 0;
  }
`;

export const StyledAvatar = styled(Avatar)`
  background-color: #20a45a;
  font-size: 1.1rem;
`;